/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Ndamanagement_Globalnda_Title3Inputs */

const en_coinvestments_ndamanagement_globalnda_title3 = /** @type {(inputs: Coinvestments_Ndamanagement_Globalnda_Title3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Global NDA`)
};

/**
* | output |
* | --- |
* | "Global NDA" |
*
* @param {Coinvestments_Ndamanagement_Globalnda_Title3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_ndamanagement_globalnda_title3 = /** @type {((inputs?: Coinvestments_Ndamanagement_Globalnda_Title3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Ndamanagement_Globalnda_Title3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_ndamanagement_globalnda_title3(inputs)
});
export { coinvestments_ndamanagement_globalnda_title3 as "coInvestments_ndaManagement_globalNda_title" }